// https://stackoverflow.com/questions/43118692/typescript-filter-out-nulls-from-an-array
export const nonNullElement = <T>(itm: T | null | undefined): itm is T =>
  itm !== null && itm !== undefined;
